<template>
    <ul class="mg-tabs flex list-reset bg-white ui-has-state" :class="[{'ui-has-state--is-loading': marketDataIsLoading}]">
        <li class="w-1/2 z-20" v-for="(tab, index) in tabs" :key="index" @click="tabClick(index)">
            <button :class="[
                    {'bg-white': selected == index}, 
                    {'opacity-100': selected == index},
                    {'mg-banded-secondary-lightest': selected != index}
                ]" class="h-full hover:bg-white block rounded-none w-full border-t-8 mg-border-accent-2 heading-font text-lg md:text-2xl plain-button p-4 md:p-6 mg-color-secondary opacity-75 text-left sm:text-center">{{tab.label}}<tooltip v-if="tab.info" :text="tab.info"></tooltip></button>
        </li>
    </ul>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import Tooltip from "@/vue-components/tooltip";
export default {
    name: "market-data-tabs",
    components: {
        tooltip: Tooltip
    },
    data() {
        return {
            tabs: [
                {
                    name: "USDA-data",
                    label: "USDA Export Data",
                    info: false
                },
                {
                    name: "GIAF-eq",
                    label: "Feed Grains In All Forms Equivalents",
                    info: "USDA export data converted to Feed Grain Equivalents"
                },
                {
                    name: "corn-eq",
                    label: "Corn Equivalents",
                    info: "USDA export data converted to Corn Equivalents"
                }
            ],
            selected: 0
        };
    },
    computed: {
        ...mapState(["marketDataMode", "showQty", "marketDataIsLoading"])
    },
    methods: {
        ...mapMutations(["setMarketDataMode", "updateQtyOption"]),
        ...mapActions([
            "activeCommodities",
            "activateSingleCommodity",
            "getMarketData",
            "getMarketDataFeedGrain",
            "getMarketDataCornEquiv",
            "getExportTotals",
            "getExportTotalsFeedGrain",
            "getExportTotalsCornEquiv",
            "selectMarket",
            "handleActiveUnit"
        ]),
        tabClick(index) {
            if (this.selected == index) return;

            this.selected = index;

            this.setDataMode();

            if (this.marketDataMode == "GIAF-eq") {
                Promise.all([
                    this.getExportTotalsFeedGrain(),
                    this.getMarketDataFeedGrain()
                ]).then(() => {
                    this.handleActiveUnit();
                    this.selectMarket();
                    this.updateQtyOption(true);
                });
            } 
            else if (this.marketDataMode == "corn-eq") {
                return Promise.all([
                    this.getExportTotalsCornEquiv(),
                    this.getMarketDataCornEquiv()
                ]).then(() => {
                    this.handleActiveUnit();
                    this.selectMarket();
                    this.updateQtyOption(true);
                });
            }  
            else {
                Promise.all([
                    this.getExportTotals(),
                    this.getMarketData()
                ]).then(() => {
                    this.handleActiveUnit();
                    this.selectMarket();
                    this.updateQtyOption(true);

                    if (this.showQty && this.activeCommodities.length) {
                        this.activateSingleCommodity("all");
                    }
                });
            }
        },
        setDataMode() {
            const tabInfo = this.tabs[this.selected];
            this.setMarketDataMode(tabInfo.name);
        }
    },
    created() {
        if (this.marketDataMode == "GIAF-eq") {
            this.selected = 1;
        }
        this.setDataMode();
    }
};
</script>



// WEBPACK FOOTER //
// src/js/vue-components/market-data-tabs.vue